import { composeU } from '@bem-react/core';
import {
    Icon as IconPresenter,
    withTypeClose
} from '@yandex-lego/components/Icon/desktop';

import { withTypePlus } from 'client/common/components/lego/icon/_type/icon_type_plus';

const Icon = composeU(
    withTypeClose,
    withTypePlus
)(IconPresenter);

export default Icon;
